// Shared utility functions for genre filtering
// Handles both single genres and comma-separated multiple genres

/** Number of top genres considered relevant for filtering (ordered by AME weight) */
export const PRIMARY_GENRE_COUNT = 5;

/** Returns only the primary (most relevant) genres based on array position */
export function getPrimaryGenres(genres: string[] | null | undefined): string[] {
  if (!genres || !Array.isArray(genres)) return [];
  return genres.slice(0, PRIMARY_GENRE_COUNT);
}

/**
 * Parses a genre filter string into individual genre terms
 * Handles comma-separated values like "rock, pop, hip-hop"
 */
export function parseGenreFilter(genreFilter: string): string[] {
  if (!genreFilter || !genreFilter.trim()) return [];
  
  return genreFilter
    .split(',')
    .map(genre => genre.trim().toLowerCase())
    .filter(genre => genre.length > 0);
}

/**
 * Checks if artist genres match any of the filter genres
 * Supports both array and string artist genres
 */
export function artistGenresMatchFilter(artistGenres: string[] | string | null | undefined, genreFilter: string): boolean {
  if (!genreFilter || !genreFilter.trim()) return true;
  
  const filterGenres = parseGenreFilter(genreFilter);
  if (filterGenres.length === 0) return true;
  
  // Convert artist genres to searchable string (only primary genres)
  const primaryGenres = Array.isArray(artistGenres)
    ? getPrimaryGenres(artistGenres)
    : [];
  const artistGenresString = primaryGenres.join(' ').toLowerCase();
  
  // Check if any of the filter genres match the artist's genres
  return filterGenres.some(filterGenre => 
    artistGenresString.includes(filterGenre)
  );
}

/**
 * Formats genre list for display (used in UI components)
 */
export function formatGenreList(genres: string[] | string | null | undefined): string {
  if (!genres) return '';
  
  if (Array.isArray(genres)) {
    return genres.join(', ');
  }
  
  return genres;
}